import { TransactionType } from "../../types";

export const QUERY_KEYS = {
  DASHBOARD: "dashboard-stats",
  RUNS: "runs",
  RUN: (id: string) => ["run", id],
  EXECUTION: (id: string) => ["execution", id],
  PROPERTIES: "properties",
  EXECUTION_PROPERTIES: (id: string) => ["execution-properties", id],
  HEALTH: "health",
  SCRAPER_INFO: "scraper-info",
  BLACKLISTS: "blacklists",
  BLACKLIST_STATS: "blacklist-stats",
  // Prefix shared by every Sales Dashboard query so one invalidation hits them all.
  SALES: "sales",
} as const;

export const REFETCH_INTERVALS = {
  FAST: 5000,
  MEDIUM: 10000,
  SLOW: 30000,
} as const;

export const PLATFORMS = [
  { value: "homegate", label: "Homegate" },
  { value: "immoscout24", label: "Immoscout24" },
] as const;

export const TRANSACTION_TYPES: TransactionType[] = [
  { id: 1, value: "rent", label: "Rent", icon: "Home" },
  { id: 2, value: "buy", label: "Buy", icon: "ShoppingCart" },
];

export const CANTONS = [
  { value: "zurich", label: "Zürich" },
  { value: "bern", label: "Bern" },
  { value: "lucerne", label: "Luzern" },
  { value: "uri", label: "Uri" },
  { value: "schwyz", label: "Schwyz" },
  { value: "obwalden", label: "Obwalden" },
  { value: "nidwalden", label: "Nidwalden" },
  { value: "glarus", label: "Glarus" },
  { value: "zug", label: "Zug" },
  { value: "fribourg", label: "Freiburg" },
  { value: "solothurn", label: "Solothurn" },
  { value: "basel-stadt", label: "Basel-Stadt" },
  { value: "basel-landschaft", label: "Basel-Landschaft" },
  { value: "schaffhausen", label: "Schaffhausen" },
  { value: "appenzell-ausserrhoden", label: "Appenzell Ausserrhoden" },
  { value: "appenzell-innerrhoden", label: "Appenzell Innerrhoden" },
  { value: "st-gallen", label: "St. Gallen" },
  { value: "graubuenden", label: "Graubünden" },
  { value: "aargau", label: "Aargau" },
  { value: "thurgau", label: "Thurgau" },
  { value: "ticino", label: "Tessin" },
  { value: "vaud", label: "Vaud" },
  { value: "valais", label: "Wallis" },
  { value: "neuchatel", label: "Neuchâtel" },
  { value: "geneva", label: "Genf" },
  { value: "jura", label: "Jura" },
] as const;

export const PROPERTY_FIELDS = [
  { value: "platform", label: "Platform", category: "core", required: true },
  {
    value: "transaction_type",
    label: "Transaction Type",
    category: "core",
    required: true,
  },
  {
    value: "categories",
    label: "Categories",
    category: "core",
    required: true,
  },
  {
    value: "listing_url",
    label: "Listing URL",
    category: "core",
    required: true,
  },
  // Contact information (optional)
  {
    value: "contact_name",
    label: "Contact Name",
    category: "contact",
    required: false,
  },
  {
    value: "phone_number",
    label: "Phone Number",
    category: "contact",
    required: false,
  },
  // Property details
  {
    value: "title",
    label: "Property Title",
    category: "details",
    required: false,
  },
  {
    value: "description",
    label: "Description",
    category: "details",
    required: false,
  },
  {
    value: "gross_price",
    label: "Price",
    category: "details",
    required: false,
  },
  {
    value: "number_of_rooms",
    label: "Number of Rooms",
    category: "details",
    required: false,
  },
  {
    value: "living_space",
    label: "Living Space (m²)",
    category: "details",
    required: false,
  },
  { value: "floor", label: "Floor", category: "details", required: false },

  // Location
  {
    value: "street_number",
    label: "Street",
    category: "location",
    required: false,
  },
  { value: "locality", label: "City", category: "location", required: false },
  {
    value: "postal_code",
    label: "ZIP Code",
    category: "location",
    required: false,
  },

  // Additional
  {
    value: "legal_name",
    label: "Legal Name",
    category: "additional",
    required: false,
  },
  {
    value: "image_urls",
    label: "Image URLs",
    category: "additional",
    required: false,
  },
] as const;

// Legacy support - keep the old constant for backward compatibility
export const REQUIRED_FIELDS = PROPERTY_FIELDS.filter(
  (field) => field.required
).map((field) => ({
  value: field.value,
  label: field.label,
}));
